export default __webpack_public_path__ + "5417dda6fe685d74cddbf8fd2b59244d.svg";